module.exports = __webpack_public_path__ + "static/media/book2.e5cd0d71.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/inviteNew/book2.png
// module id = 1863
// module chunks = 6